import React from 'react';
import _ from 'lodash';
import Modal from 'shared/components/modals/Modal';
import {observer} from 'mobx-react';
import TaskContent from 'main/components/modals/task_modal/TaskContent';
import TaskDetails from 'main/components/modals/task_modal/TaskDetails';

const TaskModal = ({uiState}) => {
  const {task, modalOpen} = uiState;
  if (!task) return null;

  return (
    <Modal
      isOpen={modalOpen}
      onHide={() => uiState.closeTaskModal()}
      closeButton={false}
      size='md'
    >
      <TaskDetails uiState={uiState}/>
      <TaskContent uiState={uiState}/>
    </Modal>
  );
};

export default observer(TaskModal);
